/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=5d06c6fe&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=js"
export * from "./dashboards.vue?vue&type=script&lang=js"
import style0 from "./dashboards.vue?vue&type=style&index=0&id=5d06c6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06c6fe",
  null
  
)

export default component.exports